import { routes } from '../config';

export default {
  welcome: {
    access: ['partner'],
  },
  dashboardMenu: {
    access: ['superAdmin', 'partner'],
  },
  wines: {
    access: ['superAdmin', 'partner'],
  },
  wineLists: {
    access: ['superAdmin', 'partner'],
  },
  wineLabels: {
    access: ['superAdmin', 'partner'],
  },
  partner: {
    access: ['superAdmin', 'partner'],
  },
  users: {
    access: ['superAdmin'],
  },
  subscriptions: {
    access: ['partner'],
  },
  wineLovers: {
    access: ['superAdmin'],
  },
  wineLoversActivities: {
    access: ['superAdmin', 'partner'],
  },
  campaigns: {
    access: ['superAdmin', 'partner'],
  },
  tasteimonials: {
    access: ['superAdmin', 'partner'],
  },
};

const getFirstPageRouteByRole = currentUser => {
  const firstOpenedPages = {
    superAdmin: routes.wines.path,
    partner: routes.welcome.path,
  };
  return currentUser?.usersRole?.name ? firstOpenedPages[currentUser.usersRole.name] : routes.login.path;
};

export { getFirstPageRouteByRole };
